<template>
  <div class="flex items-center relative">
    <svg width="24" height="24" class="flex-none absolute icon">
      <use :xlink:href="`#${icon}`" />
    </svg>

    <slot />
  </div>
</template>

<script>
export default {
  props: ['icon']
}
</script>

<style scoped>
.icon {
  left: 12px;
}

.input {
  padding-left: 40px;
}
</style>